import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FileManagerItem } from '../../../modules/file-manager/classes/file-manager.model';
import { environment } from '../../../../environments/environment';
import { GlobalDataStorageService } from '@dash/randy/security/service/global-data-storage.service';
import { FileManagerItemService } from '../../../modules/file-manager/services/file-manager-items.service';

@Component({
  selector: 'app-file-manager-item-icon',
  templateUrl: './file-manager-item-icon.component.html',
  styleUrls: ['./file-manager-item-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FileManagerItemIconComponent implements OnInit {
  @Input() fileManagerItem: FileManagerItem;
  @Output() fileUploadFailed = new EventEmitter<boolean>();

  public src: string;
  public isPreviewableMedia = false;

  public baseUrl: string;
  broken: boolean = false;
  private readonly destroyRef = inject(DestroyRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private destroyed = false;

  constructor(
    private tokenStorage: GlobalDataStorageService,
    private fileManagerItemService: FileManagerItemService,
  ) {}

  ngOnInit(): void {
    this.destroyRef.onDestroy(() => {
      this.destroyed = true;
    });

    this.baseUrl = environment.cdnUrl + this.tokenStorage.getSelectedApplication().id + '/';
    this.src = this.getFileUrl();
    this.isPreviewableMedia = this.fileManagerItem.type === 'IMAGE' || this.fileManagerItem.type === 'VIDEO';

    this.pollForPreviewProcessed().catch(err => {
      console.log(err);
      this.setBrokenImg();
    });
  }

  getFileUrl(): string {
    let fullUrl = this.baseUrl + this.fileManagerItem.id;
    if (this.fileManagerItem.thumbnail || this.fileManagerItem.thumbnail === undefined) {
      fullUrl = fullUrl + '/thumbnail';
    }
    return fullUrl;
  }

  setDefaultImg(): void {
    this.src = 'https://kleksi.com/img/kleksi_logo_anim.png';
  }

  async pollForPreviewProcessed(): Promise<void> {
    if (!this.isPreviewableMedia || this.fileManagerItem.uploadedAt || !this.fileManagerItem.id) {
      return;
    }

    const item = await this.fileManagerItemService
      .waitForUploadedObject(this.fileManagerItem.id)
      .catch(err => {
        console.log(err, 'Upload failed');
        this.fileUploadFailed.next(true);
        this.setBrokenImg();
        return null;
      });

    if (!item || this.destroyed) {
      return;
    }

    this.fileManagerItem = item;
    this.changeDetectorRef.markForCheck();
  }

  setBrokenImg() {
    this.broken = true;
    this.src = 'https://kleksi.com/img/error_owl.png';
    this.changeDetectorRef.markForCheck();
  }
}
